import React from "react";
import styled from "styled-components";

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';

import { SiteSiteMetadataAuthor } from "graphql-types";
import { rhythm } from "../../utils/typography";
import { device } from "../../styles/constants";

import { data } from './newsData';

interface AwesomeProps {
  author: SiteSiteMetadataAuthor;
}

const Awesome: React.FunctionComponent<ProjectsAwesome> = ({
  author,
}): React.ReactElement => {
	
	const styledHead = (val) => {return {width: val+"px",textAlign:"center",color: '#c62828'}};

	const CaptionElement = () =>
		<h4 style={{ borderRadius: '0.25em', textAlign: 'left', color: 'black', border: '1px solid black', padding: '0.5em', fontWeight: 'normal' }}>This space contains amazing & worth sharing work done by various people in the world.</h4>;
	
	const columns = [
		{id:"1",dataField: "headline", text: "Headline",
			headerStyle: styledHead(400),
			align: "justify"
		},
		{id:"2",dataField: "link", text: "Link",
			headerStyle: styledHead(120),
			formatter: (cell) => <u><a target="_blank" href={cell[1]}>{cell[0]}</a></u>,
			align: "center"
		},
		{id:"3",dataField: "date", text: "Date",
			headerStyle: styledHead(90),
			align: "center"
		},
		{id:"4",dataField: "tags", text: "Tags",
			headerStyle: styledHead(100),
			align: "center"
		} 
	];

  return (
    <Root>
		
		<div className="App">
			<BootstrapTable id="table"
			  keyField="id"
			  data={ data }
			  columns={ columns }
			  striped
			  hover
			  condensed
			  caption={<CaptionElement />}
			/>
		</div>
    </Root>
  );
};

const Root = styled.div`

  grid-gap: ${rhythm(2)};
  margin-top: ${rhythm(-2)};

  @media ${device.tablet} {
    grid-template-columns: minmax(20%, 200px) 70%;
  }
`;

export default Awesome;